export class MomaUpdatesNav {
	constructor() {
		this.addEventListeners();
	}

	addEventListeners() {
		jQuery(($) => {
			let activeMenuItem = $('.moma-updates-nav nav li.current-menu-parent');
			if(activeMenuItem.length) {
				activeMenuItem.children('ul').slideDown();
				activeMenuItem.addClass('open');
			}
			let momaMenuLinks = $('.moma-updates-nav nav > ul > li > a');
			momaMenuLinks.on('mouseenter mousemove', function(e) {
				e.preventDefault();
				e.stopPropagation();
			});
			momaMenuLinks.on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				let parentElement = $(this).parent(), navElements = $('.moma-updates-nav nav > ul > li');
				if(parentElement.hasClass('open')) {
					parentElement.children('ul').slideUp();
					parentElement.removeClass('open');
				} else {
					navElements.each(function() {
						if($(this).hasClass('open')) {
							$(this).children('ul').slideUp();
							$(this).removeClass('open');
						}
					});
					parentElement.children('ul').slideDown();
					parentElement.addClass('open');
				}
			});
		});
	}
}